module.exports = __webpack_public_path__ + "static/scale-model-of-baton-rouge-louisiana-df43c0a2de24e3a2ec6d9d6e7d1a9cb3.png";